import { useState, useEffect } from 'react';

const lightTheme = 'light';
const darkTheme = 'dark';

const getThemeFromLocalStorage = () => {
    return localStorage.getItem('theme');
};

const setThemeToLocalStorage = (newTheme) => {
    localStorage.setItem('theme', newTheme);
};

const getUserPreferredTheme = () => {
    const isUserPrefersDark =
        matchMedia && matchMedia('(prefers-color-scheme: dark)').matches;
    return isUserPrefersDark ? darkTheme : lightTheme;
};

const useThemeToggle = () => {
    const [theme, setTheme] = useState(
        () => getThemeFromLocalStorage() || getUserPreferredTheme()
    );

    useEffect(() => {
        setThemeToLocalStorage(theme);

        const rootElement = document.body;
        if (theme === 'dark') {
            rootElement.classList.add('dark');
            rootElement.classList.remove('light');
        } else {
            rootElement.classList.add('light');
            rootElement.classList.remove('dark');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    return { theme, toggleTheme };
};


export default useThemeToggle;
